import { api } from './api';

export type IncptLedgerKind =
  | 'purchase'
  | 'admin_grant'
  | 'promocode'
  | 'referral'
  | 'transfer_out'
  | 'transfer_in';

export interface IncptTransferDto {
  id: string;
  kind: IncptLedgerKind;
  amount: string;
  symbol: string;
  fee: string;
  counterpartyUserId: string | null;
  counterpartyTgUserId: string | null;
  counterpartyNickname: string | null;
  groupId: string | null;
  note: string | null;
  createdAt: string;
  status: 'success';
}

export interface IncptResolvedRecipient {
  tgUserId: string;
  displayName: string | null;
}

export function fetchIncptTransfers(initData: string, limit = 50) {
  return api<{ transfers: IncptTransferDto[] }>(
    initData,
    `/v1/incpt/transfers?limit=${limit}`,
  );
}

export function resolveIncptRecipient(
  initData: string,
  to: { tgUserId: string } | { username: string },
) {
  const query = new URLSearchParams(
    'tgUserId' in to ? { tgUserId: to.tgUserId } : { username: to.username },
  );
  return api<IncptResolvedRecipient>(initData, `/v1/incpt/resolve-recipient?${query}`);
}

export function sendIncptTransfer(
  initData: string,
  body: { toTgUserId: string; amount: string },
  opts: { idempotencyKey: string; reauthToken?: string },
) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Idempotency-Key': opts.idempotencyKey,
  };
  if (opts.reauthToken) headers['X-Reauth'] = opts.reauthToken;
  return api<{ transfer: IncptTransferDto; balance: string; fee: string }>(
    initData,
    '/v1/incpt/transfers',
    {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    },
  );
}
